import { useIntercom } from "@/hooks/useIntercom.ts";
import { useLogRocket } from "@/hooks/useLogRocket.ts";
import { useOpenTelemetry } from "@/hooks/useOpenTelemetry.ts";
import { usePageViewTracking } from "@workleap-ai/shared";
import type { PropsWithChildren } from "react";

export const Bootstrapper = ({ children }: PropsWithChildren) => {
    useOpenTelemetry();
    useLogRocket();
    useIntercom();
    usePageViewTracking();

    return children;
};
